import { makeStyles, Typography } from "@material-ui/core"
import React from "react"
import { useRetrospectiva } from "../context/RetrospectivaContext"
import { CointainerDados } from "./ContainerDados"
import { ContainerInsta } from "./ContainerInsta"
import { linesSvg } from "./Svg"

const useStyles = makeStyles(() => ({
    titulo: {
        fontSize: 22,
        color: "white",
        fontWeight: 800,
        textShadow: "0px 6px 18px rgba(0,0,0,.55)",
        letterSpacing: 0.2,
        marginBottom: 6,
    },
    conteudo: {
        fontSize: "2rem",
        lineHeight: 1.0,
        color: "white",
        fontWeight: 800,
        textShadow: "0px 10px 28px rgba(0,0,0,.6)",
        marginBottom: 22,
    },
}))

export function Faturamento() {
    const classes = useStyles()
    const dadosRestrospectiva = useRetrospectiva()
    const gradient = "linear-gradient(180deg, #34d399 0%, #0d9488 50%, #0f172a 100%)"
    const formatacaoBRL = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" })

    return (
        <ContainerInsta img={linesSvg} gradiente={gradient}>
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    background:
                        "radial-gradient(120% 70% at 50% 80%, rgba(0,0,0,.4) 0%, rgba(0,0,0,0) 55%)",
                    pointerEvents: "none",
                }}
            />

            <CointainerDados>
                <>
                    <Typography className={classes.titulo}>Seu faturamento foi de</Typography>
                    <Typography className={classes.conteudo}>
                        {formatacaoBRL.format(dadosRestrospectiva?.pedidos.faturamento ?? 0)}
                    </Typography>
                </>
            </CointainerDados>
        </ContainerInsta>
    )
}
